import { FormGroup, Input } from '@snsw/react-component-library';
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  ownerId: string;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;

  parentContainer: HTMLDivElement;
}

export const PropertyNameField = ({ ownerId, value, onChange, errorMessage, parentContainer }: Props) => {
  const hasError = !!errorMessage;

  const portalRef = useRef(document.createElement('div'));

  useEffect(() => {
    if (parentContainer) {
      // Input field order for manual addresses is - Street Address, Suburb, State, Postcode, Country
      // We want to put the property name field before the suburb, so we just need to find the second input field,
      // then add our portal before the input field's parent (FormGroup).
      const suburbInput = parentContainer.getElementsByTagName('input')[1];
      const suburbInputFormGroup = suburbInput?.parentNode;

      if (!suburbInputFormGroup) {
        console.warn(
          'Cannot add the "Property name" field - could not find the "Suburb" input to prepend the field to'
        );
        return;
      }

      const manualAddressContainer = suburbInputFormGroup?.parentElement;
      manualAddressContainer.insertBefore(portalRef.current, suburbInputFormGroup);
    }

    return () => portalRef.current.remove();
  }, [parentContainer]);

  const handleChange = (event) => onChange(event.target.value);

  // The layout of this component should reflect the form groups/inputs in Kiama's ManualAddress component.
  return createPortal(
    <>
      <FormGroup
        id={`${ownerId}-manual-address-form-group-property-name`}
        label="Property or building name (optional)"
        errorMessage={errorMessage}
        hasError={hasError}
        isRequired={true}
      >
        <Input
          id={`${ownerId}-manual-address-property-name`}
          name="propertyName"
          value={value}
          onChange={handleChange}
        />
      </FormGroup>
    </>,
    portalRef.current
  );
};
